import { useQuery } from '@tanstack/react-query'
import { apiClient, getSessionTokenHeaders } from './client'
import type { EnrollmentDocumentStatus, EnrollmentDocumentType } from './types/enrollment'

const BASE_URL = '/api/v1/b2b-enrollment'

export interface RequiredEnrollmentDocument {
  id?: number | null
  code: string
  name: string
  description?: string | null
  documentType: EnrollmentDocumentType
  instructions?: string | null
  acceptedFormats?: string | null
  maxFileSizeMb?: number | null
  displayOrder?: number | null
  uploaded: boolean
  uploadedStatus?: EnrollmentDocumentStatus | null
  uploadedDocumentId?: number | null
}

export const listEnrollmentRequiredDocumentsRequest = async (sessionToken: string) => {
  const response = await apiClient.get<RequiredEnrollmentDocument[]>(
    `${BASE_URL}/session/${encodeURIComponent(sessionToken)}/required-documents`,
    {
      headers: getSessionTokenHeaders(sessionToken)
    }
  )

  return response.data
}

export const useEnrollmentRequiredDocuments = (sessionToken: string | null | undefined) => {
  return useQuery({
    queryKey: ['enrollment', 'required-documents', sessionToken],
    queryFn: () => listEnrollmentRequiredDocumentsRequest(sessionToken!),
    enabled: !!sessionToken
  })
}
